import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-creative-agency',
  templateUrl: './creative-agency.component.html',
  styleUrls: ['./creative-agency.component.scss']
})
export class CreativeAgencyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
